import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface GarageDoorProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GarageDoor: React.FC<GarageDoorProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [garageDoor, set_garageDoor] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Exterior Finishes']?.['Garage Door'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Finishes': { ...b.values?.['Exterior Finishes'], 'Garage Door': v } } })
    );
    const label = 'Garage Door';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(garageDoor)}
                />
            ) : (
                <MoneyBox
                    id={'garageDoor'}
                    allowNegative={false}
                    value={garageDoor}
                    onChange={(value) => set_garageDoor(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
